module.exports = __webpack_public_path__ + "static/kohlanta-8c99a2983a5e11bd918bcf1d0b598d5f.png";